import { ReactNode } from 'react';

import { Amount, ApiDate, RESPONSE_STATUSES } from '../../../../../api/interfaces';

export enum PAYMENT_METHODS {
  'EXTERNAL_BANK_TRANSFER_ACCESS' = 'EXTERNAL_BANK_TRANSFER_ACCESS',
  'EXTERNAL_BANK_TRANSFER_PROVIDUS' = 'EXTERNAL_BANK_TRANSFER_PROVIDUS',
  'MANUAL_CREDIT' = 'MANUAL_CREDIT'
}

export enum PAYMENT_STATUSES {
  'CONFIRMED' = 'CONFIRMED',
  'PENDING' = 'PENDING',
  'REJECTED' = 'REJECTED'
}

export enum ADD_FUNDS_TO_THE_WALLET_STEPS {
  'ORDER_FORM' = 'ORDER_FORM',
  'ORDER_SUMMARY' = 'ORDER_SUMMARY',
  'ORDER_CONFIRMATION' = 'ORDER_CONFIRMATION'
}

export enum ADD_FUNDS_TO_THE_WALLET_FORM {
  METHOD = 'method',
  AMOUNT = 'amount'
}

export interface AddFundsToTheWalletOrder {
  [ADD_FUNDS_TO_THE_WALLET_FORM.AMOUNT]: number;
  [ADD_FUNDS_TO_THE_WALLET_FORM.METHOD]: PAYMENT_METHODS;
}

export interface AddFundsOrderFilters {
  [ADD_FUNDS_TO_THE_WALLET_FORM.METHOD]: string;
  [ADD_FUNDS_TO_THE_WALLET_FORM.AMOUNT]: string;
}

export interface AddFundsToTheWalletOrderData {
  creditAmount: Amount;
  method: PAYMENT_METHODS;
}

export interface AddFundsToTheWalletOrderRequest extends AddFundsToTheWalletOrderData {
  operationId: string;
}

export interface AddFundsToTheWalletOrderResponse {
  bankName: string | null;
  bankAccountNumber: string;
  transferTitle: string;
  status: RESPONSE_STATUSES;
}

export interface WalletCreditResponse {
  operationId: string;
  creditStatus: PAYMENT_STATUSES;
  creditType: PAYMENT_METHODS;
  creditAmount: Amount;
  attemptDate: ApiDate;
  confirmDate: ApiDate | null;
}

export interface WalletCreditDetailsResponse {
  bankName: string | null;
  bankAccountNumber: string;
  transferTitle: string;
  confirmedCreditAmount: Amount | null;
  rejectDate: ApiDate | null;
  detailsMessage: string | null;
  type: PAYMENT_METHODS;
}

interface WalletCreditOperationInfo extends WalletCreditResponse {
  details: WalletCreditDetailsResponse;
}

export interface WalletCreditInfoResponse {
  info: WalletCreditOperationInfo;
  status: RESPONSE_STATUSES;
}

export interface WalletCreditsHistoryResponse {
  credits: WalletCreditResponse[];
}

export interface WalletCreditsHistoryTableData {
  id: string;
  status: PAYMENT_STATUSES;
  creditType: PAYMENT_METHODS;
  amount: number;
  date: ApiDate;
  actions: ReactNode;
}

export interface WalletCreditsHistoryTableRowActions {
  openDetails: (id: string) => void;
}
